import React, { useCallback, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Button } from 'src/components';

import { useAnimatedView } from 'src/hooks/useAnimatedView';

import {
  ArrowRightBottomIcon,
  Background1Image,
  EllipseImage,
  HomeStars,
  HomeWallet,
  PhoneImage,
  ShadowWaveImage,
} from 'src/assets';
import './investments.scss';
import { ROUTE } from 'src/constants';

export const Investments = () => {
  const { t, i18n } = useTranslation();

  const navigate = useNavigate();

  const ref = useRef();
  const { isVisible } = useAnimatedView(ref);

  const onClickButton = useCallback(() => {
    navigate(ROUTE.AUTH.SIGNIN?.replace(':language', i18n.language));
  }, [i18n.language, navigate]);

  return (
    <div className="investments">
      <div className={`investments-content ${isVisible ? 'active-animation' : ''}`} ref={ref}>
        <div className="investments-title">
          <h1>
            <blue-underline>{t('investments:investments')}</blue-underline>{' '}
            {t('investments:forEveryone')} <blue-text>{t('investments:startNow')}</blue-text>
          </h1>
          <div className="investments-title-subtitle">
            {t('investments:subtitle')} <strong>{t('investments:multiplyFunds')}</strong>{' '}
            {t('investments:finances')}
          </div>
          <div className="investments-button">
            <Button
              title={t('title:getStarted')}
              icon={ArrowRightBottomIcon}
              onClick={onClickButton}
            />
          </div>
        </div>
        <div className="investments-image">
          <img src={PhoneImage} alt={PhoneImage} className="investments-image-main" />
          <img src={EllipseImage} alt={EllipseImage} className="investments-image-4" />
          <img src={EllipseImage} alt={EllipseImage} className="investments-image-5" />
          <img src={HomeWallet} alt={HomeWallet} className="investments-image-7" />
          <img src={HomeStars} alt={HomeStars} className="investments-image-8" />
        </div>

        <img src={Background1Image} alt={Background1Image} className="investments-image-1" />
        <img src={ShadowWaveImage} alt={ShadowWaveImage} className="investments-image-3" />
      </div>
    </div>
  );
};
